export default {
  create(url) {
    return {
      getPath: () => url,
    };
  },
};



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/url_converters/static_url_converter.js